import Svg, { Defs, LinearGradient, Path, Stop } from 'react-native-svg';
import { TIllustrationProps } from './types';

export const IllustrationShield = ({
  width = 300,
  height = 300,
  className,
}: TIllustrationProps) => (
  <Svg
    width={width}
    height={height}
    fill="none"
    viewBox="0 0 300 300"
    className={className}
  >
    <Path
      fill="#FF8E7A"
      fillRule="evenodd"
      d="M93.97 96.481c-2.614 1.362-4.346 3.934-4.51 6.876-.848 15.133-2.168 63.103 13.004 88.223 18.168 30.078 47.036 40.196 47.036 40.196V69s-13.787 5.464-29.99 14.056A4196.572 4196.572 0 0 1 93.97 96.48Zm111.062 0c2.613 1.362 4.345 3.934 4.51 6.876.847 15.133 2.167 63.103-13.006 88.223-18.168 30.078-47.035 40.196-47.035 40.196V69s13.787 5.464 29.99 14.056a4189.261 4189.261 0 0 0 25.541 13.425Z"
      clipRule="evenodd"
    />
    <Path
      fill="url(#illustration-shield-a)"
      d="M198.195 112.668c-.128-2.807-1.69-5.31-4.104-6.746a2841.927 2841.927 0 0 1-16.681-10.007c-11.188-6.766-20.708-11.07-20.708-11.07v128.204s19.933-7.969 32.477-31.659c10.263-19.38 9.598-56.03 9.016-68.722Z"
    />
    <Path
      fill="#fff"
      fillRule="evenodd"
      d="M139.171 187.121v-76.346h19.224v76.346h-19.224Z"
      clipRule="evenodd"
    />
    <Path
      fill="#fff"
      fillRule="evenodd"
      d="M186.956 158.561h-76.347v-19.224h76.347v19.224Z"
      clipRule="evenodd"
    />
    <Defs>
      <LinearGradient
        id="illustration-shield-a"
        x1="198.477"
        x2="122.947"
        y1="84.845"
        y2="109.456"
        gradientUnits="userSpaceOnUse"
      >
        <Stop stopColor="#FE7165" />
        <Stop offset="1" stopColor="#FF8D78" />
      </LinearGradient>
    </Defs>
  </Svg>
);
